<template>
  <div v-if="modalUpSelling" class="up-selling-modal toggle-up-selling">
    <div class="up-selling-modal-container">
      <div class="modal-content">
        <div id="up-selling-modal" class="card bg-orange-gradLight">
          <button class="btn-close" @click="modalUpSellingHandler">
            <img :src="close" alt="close" />
          </button>
          <h3>Adiciona mais produtos À tua encomenda</h3>
          <p class="sub-title">
            Completa a tua encomenda com um dos nossos produtos.
          </p>
          <div class="card-body">
            <swiper class="swiper" :options="swiperOption">
              <swiper-slide
                v-for="(suggestion, index) in storedItems"
                :key="index"
              >
                <product-card
                  :product-info="suggestion"
                  :product-quantity="suggestion.qty"
                ></product-card>
              </swiper-slide>
              <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
          </div>
          <a href="/checkout" class="btn-text-only"
            >Continuar para o checkout</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import icClose from "../../svg/ic_close_orange.svg";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import ProductCard from "./product-card.vue";

export default {
  name: "swiper-example-multiple-slides-per-biew",
  title: "Multiple slides per view",
  components: {
    swiper,
    swiperSlide,
    ProductCard,
  },
  props: {
    suggestionsProducts: {
      required: true,
    },
  },
  data() {
    return {
      storedItems: [],
      close: icClose,
      modalUpSelling: false,
      swiperOption: {
        slidesPerView: 3,
        spaceBetween: 15,
        slidesPerGroup: 3,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        breakpoints: {
          1200: {
            slidesPerView: 3,
            spaceBetween: 15,
            slidesPerGroup: 3,
          },
          1024: {
            slidesPerView: 2,
            spaceBetween: 10,
            slidesPerGroup: 2,
          },
          767: {
            slidesPerView: 1,
            spaceBetween: 10,
            slidesPerGroup: 1,
          },
          320: {
            slidesPerView: 1,
            spaceBetween: 10,
            slidesPerGroup: 1,
          },
        },
      },
    };
  },
  methods: {
    modalUpSellingHandler() {
      this.modalUpSelling = !this.modalUpSelling;
    },
    updateItems(code, qty) {
      for (let suggestion of this.storedItems) {
        if (code == suggestion.uid) {
          suggestion.qty = qty;
        }
      }
    },
    clearItems() {
      for (let suggestion of this.storedItems) {
        suggestion.qty = 0;
      }
    },
  },
  created() {
    for (let i in this.suggestionsProducts) {
      this.storedItems[i] = {};
      this.storedItems[i] = this.suggestionsProducts[i];
    }
    Livewire.on("modalUpSellingHandler", () => this.modalUpSellingHandler());
    Livewire.on("updateItemQty", (code, qty) => this.updateItems(code, qty));
    Livewire.on("clearCart", () => this.clearItems());

    //browserEvent option
    /* window.addEventListener('updateItemQty', (code, qty) => this.updateItems(code, qty)); */
  },
};
</script>

<style lang="scss" scoped>
.swiper-container {
  overflow: visible;
}
</style>
